import { ChangeEvent } from 'react';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';

interface CompanyAddressInterface {
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  isGettingCepData: boolean;
  cep: string;
  handleCepChange: (event: ChangeEvent<HTMLInputElement>) => void;
  uf: string;
  city: string;
  district: string;
  street: string;
  handleNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  number: string | number;
  handleComplementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  complement: string;
  mustFillManualy: boolean;
  handleDistrictChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleStreetChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function CompanyAddress({
  getErrorMessageByFieldName,
  isGettingCepData,
  cep,
  handleCepChange,
  uf,
  city,
  district,
  street,
  handleNumberChange,
  number,
  handleComplementChange,
  complement,
  mustFillManualy,
  handleDistrictChange,
  handleStreetChange,
}: CompanyAddressInterface) {
  return (
    <div className="dataGroup">
      <div className="title">
                2. Endereço da empresa
      </div>
      <div className="aside">
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('cep')} isLoading={isGettingCepData}>
            <label htmlFor="login">CEP</label>
            <Input
              disabled={isGettingCepData}
              placeholder="Informe o CEP"
              value={cep}
              onChange={handleCepChange}
              autoComplete="new-password"
              maxLength={9}
              error={getErrorMessageByFieldName('cep')}
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup isLoading={isGettingCepData}>
            <label htmlFor="login">UF</label>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={uf}
              autoComplete="new-password"
            />
          </FormGroup>
        </div>

      </div>

      <div className="aside">
        <div className="loginInput">
          <FormGroup isLoading={isGettingCepData}>
            <label htmlFor="login">Cidade</label>
            <Input
              disabled
              placeholder="Preenchido automaticamente"
              value={city}
              autoComplete="new-password"
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup isLoading={isGettingCepData}>
            <label htmlFor="login">Bairro</label>
            <Input
              disabled={!mustFillManualy}
              placeholder="Preenchido automaticamente"
              value={district}
              autoComplete="new-password"
              onChange={handleDistrictChange}
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup isLoading={isGettingCepData}>
            <label htmlFor="login">Logradouro</label>
            <Input
              disabled={!mustFillManualy}
              placeholder="Preenchido automaticamente"
              value={street}
              autoComplete="new-password"
              onChange={handleStreetChange}
            />
          </FormGroup>
        </div>
      </div>

      <div className="aside">
        <div className="loginInput">
          <FormGroup error={getErrorMessageByFieldName('number')}>
            <label htmlFor="login">Número</label>
            <Input
              onChange={handleNumberChange}
              placeholder="Caso não tenha, preencha 0"
              value={number}
              autoComplete="new-password"
              error={getErrorMessageByFieldName('number')}
            />
          </FormGroup>
        </div>
        <div className="loginInput">
          <FormGroup>
            <label htmlFor="login">Complemento</label>
            <Input
              onChange={handleComplementChange}
              placeholder="Complemento"
              value={complement}
              maxLength={20}
              autoComplete="new-password"
            />
          </FormGroup>
        </div>
      </div>
    </div>
  );
}
